/* eslint-disable camelcase */
import React from 'react'
import {
  Footer,
  StatusBox,
  StyledTable,
  TableCell,
  TableCellEmpty,
  TableContainer,
  TableHeader,
} from './styled'
import { Button } from '../../../../components/common/Button'

export const Table = ({ data }) => {
  const occurrence_status_json = {
    AGUARDANDO: 'Em vigilância - aguardando ação',
    OCORRENCIA: `Em ocorrência`,
    FECHADO: 'Fechado',
  }

  return (
    <TableContainer>
      <StyledTable>
        <thead>
          <tr>
            <TableHeader>Nome de usuário</TableHeader>
            <TableHeader>Telefone</TableHeader>
            <TableHeader>Base</TableHeader>
            <TableHeader>Última ocorrência</TableHeader>
            <TableHeader>Status atual</TableHeader>
            <TableHeader>Retorno do sempre alerta </TableHeader>
          </tr>
        </thead>
        <tbody>
          {!data ? (
            <tr>
              <TableCellEmpty colSpan={8}>
                Nenhum dado encontrado
              </TableCellEmpty>
            </tr>
          ) : (
            data.map((data, idx) => {
              const { last_occurrence } = data
              return (
                <tr key={idx}>
                  <TableCell>{data.name}</TableCell>
                  <TableCell>{data.number}</TableCell>
                  <TableCell>{data.base}</TableCell>
                  <TableCell>
                    {data?.last_occurrence[0]?.code
                      ? `#${data.last_occurrence[0]?.code} - ${new Date(
                          data.last_occurrence[0]?.created_at,
                        ).toLocaleDateString()}`
                      : 'Nenhuma ocorrência encontrada'}
                  </TableCell>
                  <TableCell>
                    {data?.status === 'OCORRENCIA' &&
                    data.last_occurrence.length > 0 ? (
                      <StatusBox status={occurrence_status_json[data.status]}>
                        {`${occurrence_status_json[data.status]} - #${data
                          ?.last_occurrence[0]?.code}`}
                      </StatusBox>
                    ) : (
                      <StatusBox
                        status={
                          occurrence_status_json[last_occurrence[0]?.status]
                        }
                      >
                        Em vigilância - Aguardando ação
                      </StatusBox>
                    )}
                  </TableCell>
                  <TableCell>
                    <Button.Root
                      backgroundColor={
                        data.always_alert_response[0]?.sent_at.length > 0
                          ? '#00A324'
                          : '#EF5803'
                      }
                      type="button"
                    >
                      <Button.Content
                        title={
                          data.always_alert_response.length > 0
                            ? data.always_alert_response[0].answered_at
                              ? `Respondido - ${new Date(
                                  data.always_alert_response[0].answered_at,
                                ).toLocaleString()}`
                              : `Enviado - ${new Date(
                                  data.always_alert_response[0].sent_at,
                                ).toLocaleString()}`
                            : 'Não acionado o sempre alerta'
                        }
                        color="#fff"
                      />
                    </Button.Root>
                  </TableCell>
                  {/* <TableCell>
                    <InputButton.Root
                      color="#fff"
                      backgroundColor={
                        data.status === 'Concluido' ? '#008F17' : '#B47700'
                      }
                    >
                      <InputButton.Content
                        clickAction={setIsOpenControllerOrderModal}
                        type="button"
                        value={data.status}
                      />
                    </InputButton.Root>
                  </TableCell> */}
                </tr>
              )
            })
          )}
        </tbody>
      </StyledTable>
      <Footer>
        <span>{`Listando ${data.length} usuários`}</span>
      </Footer>
    </TableContainer>
  )
}
